import { make } from 'vuex-pathify';
import { openBillAcceptor, getDevicesState, getDeviceLogo } from '../services/device.service';

const OPEN_BILLACCEPTOR = 'openBillAcceptor';
const GET_DEVICE_STATE = 'getDeviceState';
const STATE = 'devicestate';
const SET_PAUSE_UPDATES = 'setPausedUpdates';
const GET_DEVICE_LOGO = 'getDeviceLogo';
const SET_DEVICE_LOGO = 'setDeviceLogo';

const state = {
    state: {
        device: {},
        games: { resourcesUrl: null },
        billAcceptor: {},
        billDispenser: {},
        isUpdatePaused: false,
        deviceLogo: null
    }
};

const getters = {
    deviceLogo: state => state.deviceLogo
};

const actions = {
    [OPEN_BILLACCEPTOR]: async ({ state, commit, dispatch }) => {
        await openBillAcceptor();
        const deviceState = await getDevicesState();
        commit(STATE, deviceState);
    },
    [GET_DEVICE_STATE]: async ({ state, commit, dispatch }) => {
        const deviceState = await getDevicesState();
        commit(STATE, deviceState);
        return deviceState;
    },
    [SET_PAUSE_UPDATES]: async ({ state, commit, dispatch }, { isUpdatePaused }) => {
        commit(SET_PAUSE_UPDATES, isUpdatePaused);
    },
    [GET_DEVICE_LOGO]: async ({ state, commit, dispatch }) => {
        const deviceLogo = await getDeviceLogo();
        commit(SET_DEVICE_LOGO, deviceLogo);
    }
};

const mutations = {
    [STATE](device) {
        state.device = device;
    },
    [SET_PAUSE_UPDATES](state, isUpdatePaused) {
        state.isUpdatePaused = isUpdatePaused;
    },
    [SET_DEVICE_LOGO](state, deviceLogo) {
        state.deviceLogo = deviceLogo;
    }
};

export default {
    namespaced: true,
    actions,
    state,
    getters,
    mutations: { ...make.mutations(state), ...mutations }
};



// WEBPACK FOOTER //
// ./skins/xkiosk/data/device.js